<template>
  <sui-segment class="entity host" emphasis="secondary">
    <sui-form-fields>
      <sui-form-field :width="14">
        <label>{{entity.oldName}}</label>
        <sui-dropdown search selection :options="hostList" placeholder="Select host..." v-model="hostId" />
        <small>
          Requirements: {{entity.requirements.memory}}GB RAM, {{entity.requirements.cores}} cores
        </small>
      </sui-form-field>
      <sui-form-field :width="2">
        <label style="opacity:0">.</label>
        <div class="ui tiny fluid compact icon button" data-inverted data-position="left center" data-tooltip="Add new host" @click.prevent="$modals.createHost.open({}, 0, onCreateHost)" data-goal="STACK_FORM_NEW_HOST">
          <i class="ui large fitted icons">
            <i class="server fitted icon" />
            <i class="inverted corner plus fitted icon" />
          </i>
        </div>
      </sui-form-field>
    </sui-form-fields>
    <div class="ui labels">
      <sui-label image v-for="service in hostServices" :key="service.name"><Logo :serviceType="service.type" /> {{service.name}}</sui-label>
    </div>
  </sui-segment>
</template>

<script>
  import {mapGetters} from 'vuex'
  import FormEntity from '@/mixins/FormEntity'

  export default {
    name: 'FormStackHost',
    mixins: [
      FormEntity,
    ],
    data() {
      return {
        hostId: this.$attrs.value.id,
        object: 'Host',
        commonFields: ['requirements', 'oldName', 'newName', 'services'],
      }
    },
    computed: {
      ...mapGetters(['actionsById', 'hosts', 'hostsById']),
      error() {
        return this.entity && this.entity.id && this.errors && Object.values(this.errors).find(error => error)
      },
      stack() {
        return this.$parent.entity || this.$parent.$parent.entity
      },
      hostServices() {
        return this.stack.services.filter(service => service.deployTo.includes(this.entity.newName))
      },
      hostList() {
        return this.hosts.map(host => {
          const instance = host._instance
          let error = ''
          if (this.stack.services.length && host.id) {
            const busyPorts = host._remotePorts.filter(port => {
              return this.entity.services.find(service => {
                return service.remoteAccess && service.ports && service.ports.find(p => p.protocol + p.value === port.protocol + port.value)
              })
            })
            if (busyPorts.length) {
              error = 'busy ports: ' + busyPorts.map(port => port.protocol + port.value).join(', ')
            } else if (host.isCustom && host._isConnecting) {
              error = 'it is not connected yet'
            } else if (instance.cores < parseInt(this.entity.requirements.cores) || instance.memory < parseInt(this.entity.requirements.memory)) {
              error = 'doesn\'t fit the requirements'
            }
          }
          return {
            image: {src: host._logo},
            value: host.id,
            text: host.name + ' — ' + instance._fullTitle + (error ? `  (${error})` : ''),
            disabled: Boolean(error) || !this.actionsById[host.id].hostUsage,
          }
        })
      },
    },
    watch: {
      hostId() {
        const host = this.hostsById[this.hostId]
        this.createEntity(host || {})
      },
    },
    methods: {
      onCreateHost(result) {
        if (result && result.id) {
          this.hostId = result.id
        }
      },
    },
  }
</script>

<style scoped>
  .label .image { vertical-align: middle!important; margin: -.3833em .3em -.3833em -.3em!important; }
  .errors { color: #9f3a38; }
</style>
